module.exports = __webpack_public_path__ + "static/media/trophy-white.3b00fe85.svg";